import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, resolveDirective as _resolveDirective } from "vue";
const _hoisted_1 = {
  class: "product-detail"
};
const _hoisted_2 = {
  class: "box"
};
const _hoisted_3 = {
  class: "box-inner"
};
const _hoisted_4 = {
  class: "collapse-title"
};
const _hoisted_5 = {
  class: "al-title"
};
const _hoisted_6 = {
  class: "filter-options"
};
const _hoisted_7 = {
  class: "flex-input"
};
const _hoisted_8 = {
  class: "footer"
};
const _hoisted_9 = {
  class: "filter-result"
};
const _hoisted_10 = ["data-status"];
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "collapse-title"
};
const _hoisted_13 = {
  class: "title"
};
const _hoisted_14 = {
  class: "icon"
};
const _hoisted_15 = {
  class: "status"
};
const _hoisted_16 = {
  key: 0,
  class: "collapse-content"
};
const _hoisted_17 = ["data-flex"];
const _hoisted_18 = ["data-invalid", "data-edit", "onClick"];
const _hoisted_19 = {
  class: "item-wrap"
};
const _hoisted_20 = {
  key: 0,
  class: "iconfont icon-right icon-image"
};
const _hoisted_21 = {
  key: 1,
  class: "iconfont icon-right icon-image"
};
const _hoisted_22 = {
  class: "item"
};
const _hoisted_23 = {
  key: 0,
  class: "iconfont icon-dot"
};
const _hoisted_24 = ["innerHTML"];
const _hoisted_25 = {
  class: "form-layout"
};
const _hoisted_26 = {
  class: "item"
};
const _hoisted_27 = {
  key: 0,
  class: "iconfont icon-dot"
};
const _hoisted_28 = ["innerHTML"];
const _hoisted_29 = {
  class: "form-layout"
};
const _hoisted_30 = {
  key: 4,
  class: "item"
};
const _hoisted_31 = {
  key: 0,
  class: "iconfont icon-dot"
};
const _hoisted_32 = ["innerHTML"];
const _hoisted_33 = {
  key: 1
};
const _hoisted_34 = {
  class: "collapse-content"
};
const _hoisted_35 = {
  key: 1,
  class: "optional-criterias"
};
const _hoisted_36 = {
  class: "collapse-title"
};
const _hoisted_37 = {
  class: "title"
};
const _hoisted_38 = {
  class: "icon"
};
const _hoisted_39 = {
  class: "optional-description"
};
const _hoisted_40 = {
  class: "status"
};
const _hoisted_41 = {
  key: 0,
  class: "collapse-content"
};
const _hoisted_42 = ["data-flex"];
const _hoisted_43 = ["onClick", "data-invalid", "data-edit"];
const _hoisted_44 = {
  class: "item-wrap"
};
const _hoisted_45 = {
  class: "item"
};
const _hoisted_46 = {
  key: 0,
  class: "iconfont icon-dot"
};
const _hoisted_47 = ["innerHTML"];
const _hoisted_48 = {
  class: "form-layout"
};
const _hoisted_49 = {
  class: "item"
};
const _hoisted_50 = {
  key: 0,
  class: "iconfont icon-right"
};
const _hoisted_51 = ["innerHTML"];
const _hoisted_52 = {
  class: "form-layout"
};
const _hoisted_53 = {
  key: 4,
  class: "item"
};
const _hoisted_54 = {
  key: 0,
  class: "iconfont icon-dot"
};
const _hoisted_55 = ["innerHTML"];
const _hoisted_56 = {
  key: 1
};
const _hoisted_57 = {
  class: "collapse-content"
};
const _hoisted_58 = {
  class: "flex"
};
const _hoisted_59 = {
  class: "flex-body"
};
const _hoisted_60 = {
  class: "error"
};
const _hoisted_61 = {
  class: "text-left"
};
const _hoisted_62 = ["innerHTML"];
const _hoisted_63 = {
  class: "footer text-center"
};
const _hoisted_64 = ["data-text"];
const _hoisted_65 = ["data-text"];
const _hoisted_66 = {
  class: "flex"
};
const _hoisted_67 = {
  class: "ic"
};
const _hoisted_68 = {
  class: "flex-body"
};
const _hoisted_69 = {
  class: "s-header"
};
const _hoisted_70 = ["innerHTML"];
import { computed, ref, onBeforeMount, getCurrentInstance } from "vue";
import { ElNotification, ElMessage } from "element-plus";
import { useConfiguratorStore } from "@/stores/configuratorData";
import { useLoginStore } from "@/stores/LoginStore";
import OverlayComponent from "./OverlayComponent.vue";
import { openFullLoading } from "@/utils/tools";
import { configuratorIdStore } from "@/stores/configuratorIdStore";
import { useAdditionalAttrStore } from "@/stores/AdditionalAttrStore";
import OptionalAssemblyDialog from "./OptionalAssemblyDialog.vue";
import MarkdownIt from "markdown-it";
import { useI18n } from "vue-i18n";
import { isCodingCertificate } from "../utils/responseUtil";
import ProductProducts from "./productProducts.vue";
import ProductOptions from "./productOptions.vue";
import { useLoaderStore } from "@/stores/loaderState";
// import { ChangeAssembly } from "@/api/obj.api";
const svg = `
  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="48" height="48" xmlns:xlink="http://www.w3.org/1999/xlink">
    <path d="M475.428571 97.52381h73.142858v219.428571h-73.142858z m0 609.523809h73.142858v219.428571h-73.142858zM926.47619 475.428571v73.142858h-219.428571v-73.142858z m-609.523809 0v73.142858H97.52381v-73.142858zM779.215238 193.072762l51.712 51.687619-155.136 155.184762-51.736381-51.736381zM348.208762 624.054857l51.736381 51.736381-155.160381 155.136-51.712-51.687619zM193.097143 244.784762l51.687619-51.712 155.184762 155.136-51.736381 51.736381z m430.982095 431.006476l51.736381-51.736381 155.136 155.160381-51.687619 51.712z" fill="#1F9CEE"></path>
  </svg>
  `;
export default /*@__PURE__*/_defineComponent({
  __name: 'productDetail',
  props: ["refRightContent"],
  setup(__props) {
    const loading = ref(true);
    const configuratorStore = useConfiguratorStore();
    const isOptionLoading = ref(false);
    const {
      eventBus
    } = getCurrentInstance()?.appContext.config.globalProperties ?? {
      eventBus: undefined
    };
    const cis = configuratorIdStore();
    const {
      t
    } = useI18n();
    const props = __props;
    const refLeftContent = ref();
    const placeholderImage = ref("");
    placeholderImage.value = require(process.env.VUE_APP_OPTIONS_PLACEHOLDER_IMAGE);
    const checkSelectedAmmembly = ref(false);
    const checkSelectedCertificate = ref(false);
    eventBus.on("selectedAssembliesEmpty", async result => {
      checkSelectedAmmembly.value = result;
      if (result) {
        if (configuratorStore.currentProductOptionAssembly) {
          const loading = openFullLoading(false, t("text.loading"));
          eventBus.emit("selectedAssembliesEmpty", false);
          const currentOption = configuratorStore.currentProductOptionAssembly;
          const filteredAssemblies = useConfiguratorStore().apiConfiguratorResult?.ConfiguratorResult.CurrentState?.CurrentCoding.filter(item => Array.isArray(item.Originators) && currentOption && currentOption.CriteriaId && item.Optional == "No" && item.Originators.some(originator => originator.CriteriaId === currentOption.CriteriaId)).length ?? 0;
          const lastOption = useConfiguratorStore().getLastselectedCriteriaOption?.OptionId ?? "Z";
          currentOption.OptionId = filteredAssemblies ? lastOption : "Z";
          await SetCriteria(currentOption);
          useConfiguratorStore().setAllowallowOptionalModels(false);
          loading.close();
          configuratorStore.currentProductAssembly = false;
          configuratorStore.currentProductOptionAssembly = false;
        }
      }
    });
    eventBus.on("ChangeAssemblyAfter", result => {
      if (result) {
        isOpen.value = useConfiguratorStore()?.apiConfiguratorResult?.ConfiguratorResult?.CurrentState?.CurrentCriteriaIdx;
        eventBus.emit("ChangeAssemblyAfter", false);
      }
      eventBus.emit("switchToProductImage", true);
    });
    eventBus.on("selectedCertificateEmpty", async result => {
      checkSelectedCertificate.value = result;
      if (result) {
        eventBus.emit("selectedCertificateEmpty", false);
        const currentOption = configuratorStore.currentProductOptionCertificate;
        const filtered = useConfiguratorStore().apiConfiguratorResult?.ConfiguratorResult.CurrentState?.CurrentCoding.filter(item => Array.isArray(item.Originators) && currentOption && currentOption.CriteriaId && item.Optional == "No" && item.Originators.some(originator => originator.CriteriaId === currentOption.CriteriaId)).length ?? 0;
        const lastOption = useConfiguratorStore().getLastselectedCriteriaOption?.OptionId ?? "Z";
        if (currentOption && currentOption.OptionId) {
          currentOption.OptionId = filtered ? lastOption : "Z";
          const loading = openFullLoading(false, t("text.loading"));
          await SetCriteria(currentOption);
          useConfiguratorStore().setAllowallowOptionalModels(false);
          loading.close();
        }
        configuratorStore.currentProductAssembly = false;
        configuratorStore.currentProductOptionCertificate = false;
      }
    });
    const assemblyDialogVisible = computed({
      get() {
        if (configuratorStore.getassemblySelectorOpen) {
          return true;
        }
        if (configuratorStore.selectedAssemblies.length || attribute.getDataConfig.hideAssemblies || checkSelectedAmmembly.value) {
          return false;
        }
        // const openAsssemblyModel =
        //   !!configuratorStore.apiConfiguratorResult?.ConfiguratorResult.CurrentState.CurrentCoding.find(
        //     (item) =>
        //       isProductAssembly(item) &&
        //       !configuratorStore.initialAssemblies.includes(item.CodeTypeId) &&
        //       item.Optional == "Yes"
        //   );
        // if (openAsssemblyModel) {
        //   const selectedCriteria = configuratorStore.getlastSelectedCriteriaIdx;
        //   configuratorStore.setassemblySelectedUsing(selectedCriteria);
        // }
        return false;
      },
      set() {
        // Dialog should not be closed if the conditions are not fulfilled.
      }
    });
    const certificateDialogVisible = computed({
      get() {
        if (configuratorStore.getcertificateSelectorOpen !== null) {
          return configuratorStore.getcertificateSelectorOpen;
        }
        if (configuratorStore.getSelectedCertificateGroup.items.length || attribute.getDataConfig.hideAssemblies) {
          return false;
        }
        const currentCerOptions = configuratorStore.apiConfiguratorResult?.ConfiguratorResult.CurrentState?.CurrentCoding.filter(item => item.CodeTypeId != "LABEL" && item.Optional === "Yes" && configuratorStore.allowOptionalModel == true && !item?.Originators?.some(org => org.CodeTypeId !== configuratorStore.lastSelectedcodeType || org.CriteriaId !== configuratorStore.getLastselectedCriteriaOption?.CriteriaId || org.OptionId !== configuratorStore.getLastselectedCriteriaOption?.OptionId)) ?? [];
        if (currentCerOptions.length === 0) {
          return false;
        }
        const selectedAssembly = configuratorStore.getSelectedAssembly;
        const opencertificateModel = !!configuratorStore.apiConfiguratorResult?.ConfiguratorResult.CurrentState?.CurrentCoding.find(item => isCodingCertificate(item) && !configuratorStore.initialAssemblies.includes(item.CodeTypeId) && selectedAssembly?.CodeTypeId === item.Parent && configuratorStore.allowOptionalModel && item.Optional === "Yes");
        // if (opencertificateModel) {
        //   const selectedCriteria = configuratorStore.getlastSelectedCriteriaIdx;
        //   configuratorStore.setCertificateSelectedUsing(selectedCriteria);
        // }
        return opencertificateModel;
      },
      set() {
        // Dialog should not be closed if the conditions are not fulfilled.
      }
    });
    const isOpen = ref();
    const handleResultChange = event => {
      if (event) {
        isOpen.value = "1";
      } else {
        isOpen.value = "0";
      }
    };
    const autoCloseNum = ref(200);
    const checkDeliveryText = option => {
      if (option) {
        return `<i class="iconfont icon-delivery-fast"></i>` + t("label.deliveryFast") + `<br>` + `<i class="iconfont icon-delivery-slow"></i>` + t("label.deliverySlow");
      }
      // const deliverySpeedScore = Number(option.DeliverySpeedScore);
      // if (option.maxScore <= 2) {
      //   return "";
      // } else if (deliverySpeedScore === 5) {
      //   return t("label.deliveryFast");
      // } else if (deliverySpeedScore === 3 || deliverySpeedScore === 4) {
      //   return t("label.deliverySlow");
      // }
      // return "";
    };
    const setActive = option => {
      if (option.VariableValue != null) {
        option.Selected = true;
      } else {
        option.Selected = false;
      }
    };
    // const isValidInput = (evt: KeyboardEvent, option: CurrentOption) => {
    //   const charCode = evt.key.charCodeAt(0);
    //   const isNumberKey = charCode >= 48 && charCode <= 57;
    //   if (
    //     !isNumberKey &&
    //     evt.key != option.VarDecimalSeparator &&
    //     evt.key != option.VarThousandsSeparator
    //   ) {
    //     evt.preventDefault();
    //     return;
    //   }
    //   const inputElement = evt.target as HTMLInputElement;
    //   const inputValue = inputElement.value + evt.key;
    //   const parts = inputValue.split(option.VarDecimalSeparator);
    //   const integerPart = parts[0].replace(
    //     new RegExp(`\\${option.VarThousandsSeparator}`, "g"),
    //     ""
    //   );
    //   if (
    //     inputValue.includes(
    //       `${option.VarDecimalSeparator}${option.VarDecimalSeparator}`
    //     ) ||
    //     inputValue.includes(
    //       `${option.VarThousandsSeparator}${option.VarThousandsSeparator}`
    //     )
    //   ) {
    //     evt.preventDefault();
    //     return;
    //   }
    //   const decimalPart = parts[1] || "";
    //   if (integerPart.length + decimalPart.length > option.VarDigitCount) {
    //     evt.preventDefault();
    //     return;
    //   }
    //   if (decimalPart.length > option.VarDecimalsCount) {
    //     evt.preventDefault();
    //     return;
    //   }
    //   const numericValue = parseFloat(
    //     inputValue.replace(new RegExp(`\\${option.VarThousandsSeparator}`, "g"), "")
    //   );
    //   if (numericValue > option.VarMaxValue || numericValue < option.VarMinValue) {
    //     evt.preventDefault();
    //   }
    // };
    const checkDeliverySpeed = option => {
      const deliverySpeedScore = Number(option.DeliverySpeedScore);
      if (option.maxScore <= 2) {
        return "";
      } else if (deliverySpeedScore === 5) {
        return "iconfont icon-delivery-fast";
      } else if (deliverySpeedScore === 3 || deliverySpeedScore === 4) {
        return "iconfont icon-delivery-slow";
      }
      return "";
    };
    const activeFilterRef = ref("filter");
    const activeFilter = computed({
      get() {
        return attribute.getIsMobile ? "" : activeFilterRef.value;
      },
      set(newValue) {
        activeFilterRef.value = newValue;
      }
    });
    const resultFilter = computed({
      get() {
        return configuratorStore.getCurrentState?.CurrentCriteriaIdx ?? "";
      },
      set(newValue) {
        getOptions(newValue);
      }
    });
    const showLoading = ref(true);
    const getStatusClass = (criteria, NettoOption) => {
      if (resultFilter.value == criteria?.CriteriaIdx) {
        if (isOpen.value != "0") {
          return "item-default";
        }
      }
      if (criteria?.OptionDescription == "without" && NettoOption == "Z") {
        return "item-success";
      }
      if (configuratorStore.getErroredSelectedOption.includes(criteria?.CriteriaIdx)) {
        return "item-error";
      }
      if (configuratorStore.getUserSelectedOptions.includes(criteria?.CriteriaIdx) && NettoOption !== "") {
        return "item-success";
      }
      return "item-info";
    };
    const getStatusIConClass = (criteria, NettoOption) => {
      if (configuratorStore.getErroredSelectedOption.includes(criteria?.CriteriaIdx)) {
        return "iconfont icon-status-error";
      }
      if (resultFilter.value == criteria?.CriteriaIdx) {
        return "iconfont icon-status-edit";
      }
      if (criteria?.OptionDescription == "without" && NettoOption == "Z") {
        return "iconfont icon-status-success";
      }
      if (configuratorStore.getUserSelectedOptions.includes(criteria?.CriteriaIdx) || NettoOption) {
        return "iconfont icon-status-success";
      }
      return "iconfont icon-status-edit";
    };
    const handleHoverEnter = criteria => {
      configuratorStore.setCodeHoverOn(criteria.CriteriaId);
    };
    const handleHoverLeave = () => {
      configuratorStore.setCodeHoverOn("");
    };
    const getOptions = async CriteriaId => {
      isOptionLoading.value = true;
      if (configuratorStore?.getCurrentState && CriteriaId) {
        await configuratorStore.GetApiCriteria(CriteriaId, configuratorStore.getCurrentState.CurrentType);
      }
      isOptionLoading.value = false;
    };
    const filterContent = criteria => {
      if (criteriasFilter.value.length) {
        if (criteriasFilter.value.includes("completed") && configuratorStore.getUserSelectedOptions.includes(criteria.CriteriaIdx)) {
          return true;
        }
        if (criteriasFilter.value.includes("missing") && !configuratorStore.getUserSelectedOptions.includes(criteria.CriteriaIdx) && !criteria.OptionId) {
          return true;
        }
        return criteriasFilter.value.includes("conflict") && configuratorStore.getErroredSelectedOption == criteria.CriteriaIdx;
      } else {
        return true;
      }
    };
    const getFilteredValues = computed(() => {
      return groupSameCriteriaStatus.value ? [...configuratorStore.getCriteriasByType("S"), ...configuratorStore.getCriteriasByType("O")] : configuratorStore.getCriteriasByType("S");
    });
    const attribute = useAdditionalAttrStore();
    const activeFilterTitle = computed(() => {
      return activeFilter.value ? t("label.hideFilter") : t("label.showFilter");
    });
    const resetCriteriasFilter = () => {
      criteriasFilter.value = [];
      criteriasFilterResult.value = [];
      controlDropdown.value?.handleClose();
    };
    // filter options control.
    const controlDropdown = ref();
    const criteriasFilter = ref([]);
    const transFilterResult = item => {
      switch (item) {
        case "completed":
          return t("status.completed");
        case "missing":
          return t("status.missing");
        default:
          return t("status.conflict");
      }
    };
    const criteriasFilterResult = ref([]);
    const applyCriteriasFilter = () => {
      criteriasFilterResult.value = criteriasFilter.value;
      // controlDropdown.value?.handleClose();
    };
    const removeCriteriasFilterByKey = key => {
      const tmp = ref([]);
      criteriasFilterResult.value.forEach((v, k) => {
        if (k !== key) {
          tmp.value[k] = v;
        }
      });
      criteriasFilter.value = tmp.value;
      criteriasFilterResult.value = tmp.value;
    };
    const onlyLocalKey = ref("wikaapp-same-control");
    const groupSameInit = ref(null);
    const onlyLocalKeyExtended = ref("wikaapp-same-control-extended");
    const groupSameInitExtended = ref(null);
    // group status
    const groupSameStatus = computed(() => {
      const val = localStorage.getItem(onlyLocalKey.value);
      if (groupSameInit.value === null) {
        if (val === null) {
          return false;
        } else {
          return true;
        }
      }
      return groupSameInit.value;
    });
    const groupSameCriteriaStatus = computed(() => {
      const val = localStorage.getItem(onlyLocalKeyExtended.value);
      if (groupSameInitExtended.value === null) {
        if (val === null) {
          return false;
        } else {
          return true;
        }
      }
      return groupSameInitExtended.value;
    });
    const handleFilterGroup = event => {
      event.preventDefault();
      event.stopPropagation();
      const val = localStorage.getItem(onlyLocalKey.value);
      if (val === null) {
        groupSameInit.value = true;
        localStorage.setItem(onlyLocalKey.value, "true");
      } else {
        groupSameInit.value = false;
        localStorage.removeItem(onlyLocalKey.value);
      }
    };
    const optionalCriterias = computed(() => {
      if (configuratorStore.getCurrentState) {
        return configuratorStore.getCriteriasByType("O");
      }
      return [];
    });
    const handleFilterGroupSmart = event => {
      event.preventDefault();
      event.stopPropagation();
      const val = localStorage.getItem(onlyLocalKeyExtended.value);
      if (val === null) {
        groupSameInitExtended.value = true;
        localStorage.setItem(onlyLocalKeyExtended.value, "true");
      } else {
        groupSameInitExtended.value = false;
        localStorage.removeItem(onlyLocalKeyExtended.value);
      }
    };
    const markdown = new MarkdownIt({
      html: true,
      linkify: true,
      typographer: true
    });
    const visibleInfoDialog = ref(false);
    const visibleInfoHeadline = ref("");
    const visibleInfoText = ref("");
    const getCertificateInfo = id => {
      const currentProduct = configuratorStore.getSelectedProduct;
      const textInfo = configuratorStore.getTextInfo;
      const currentCodeInfo = textInfo.filter(item => item.id == currentProduct?.CodeTypeId);
      if (currentCodeInfo.length) {
        if (typeof currentCodeInfo[0].items !== "undefined") {
          const criteriasInfo = currentCodeInfo[0].items.filter(criterias => criterias.Criteria == id);
          if (criteriasInfo.length) {
            return criteriasInfo;
          }
        }
      }
      return [];
    };
    const isVisibleInfo = id => {
      if (getCertificateInfo(id).length) {
        return true;
      }
      return false;
    };
    const handleCallInfo = async (c, event) => {
      event.preventDefault();
      event.stopPropagation();
      if (c.CriteriaId !== "") {
        const info = getCertificateInfo(c.CriteriaId);
        visibleInfoDialog.value = true;
        visibleInfoText.value = markdown.render(info[0].Text).replaceAll("<a", "<a target='_blank' ");
        visibleInfoHeadline.value = c.Description;
      }
    };
    const displayHolderImage = computed(() => {
      const ret = ref(false);
      configuratorStore.getCurrentOptions.forEach(option => {
        if (option.ImageName !== "") {
          ret.value = true;
          return true;
        }
      });
      return ret.value;
    });
    const presentCategories = ["edited", "missing", "completed", "conflict"];
    const sortCriteriaValues = arr => {
      const groupedItems = arr.reduce((acc, item) => {
        let category = "";
        if (configuratorStore.getErroredSelectedOption == item.CriteriaIdx) {
          category = "conflict";
          // presentCategories.push("conflict");
        } else {
          if (configuratorStore.getUserSelectedOptions.includes(item.CriteriaIdx)) {
            category = "completed";
            // presentCategories.push("completed");
          }
          if (!configuratorStore.getUserSelectedOptions.includes(item.CriteriaIdx)) {
            category = "missing";
            // presentCategories.push("missing");
          }
          if (!item.OptionId || configuratorStore.getCurrentOptions[0]?.CriteriaIdx == item.CriteriaIdx) {
            category = "edited";
            // presentCategories.push("edited");
          }
        }
        acc[category] = acc[category] || [];
        acc[category].push(item);
        return acc;
      }, {});
      const ListOfCategoryPresentArr = removeEmptyAndDuplicates(presentCategories);
      return Object.values(ListOfCategoryPresentArr.map(key => groupedItems[key])).flat();
    };
    function removeEmptyAndDuplicates(array) {
      const nonEmptyArray = array.filter(item => item.trim() !== "");
      return [...new Set(nonEmptyArray)];
    }
    const exampleCertificate = ref("");
    exampleCertificate.value = require("@/assets/images/certificate-image-placeholder.jpg");
    const visibleAlertMessage = ref(false);
    const visibleAlertMessageDescription = ref("");
    const visibleTempVal = ref();
    const isPaneContentFlex = options => {
      let lastClass = false;
      options?.forEach(v => {
        if (v.ImageName) {
          lastClass = true;
        }
      });
      return lastClass;
    };
    function stringPad(num, length) {
      if ((num + "").length >= length) {
        return num;
      }
      return stringPad("0" + num, length);
    }
    const SetCriteria = async val => {
      const option = {
        ...val,
        confirm: false,
        fullresult: true
      };
      if (val.IsVariableOption) {
        const len = val.VarDigitCount;
        const currentVal = parseFloat(val.VariableValue + "");
        if (!Number.isNaN(currentVal)) {
          const newOptionId = stringPad(currentVal + "", len);
          option.OptionId = val.OptionId.replace(/\*/g, "") + newOptionId;
        } else {
          ElMessage({
            message: t("error.requireInput"),
            type: "error"
          });
          return false;
        }
      }
      isOptionLoading.value = true;
      if (configuratorStore.getCurrentState) {
        const codeTypeId = configuratorStore.getSelectedProduct?.CodeTypeId ?? "";
        // if (
        //   configuratorStore.currentProductAssembly &&
        //   codeTypeId !== configuratorStore.currentProductAssembly?.CodeTypeId
        // ) {
        //   codeTypeId = configuratorStore.currentProductAssembly?.CodeTypeId;
        //   await ChangeAssembly(codeTypeId);
        // }
        const setCriteriaValue = await configuratorStore.SetApiCriteria(option, codeTypeId);
        if (typeof setCriteriaValue === "string") {
          isOptionLoading.value = false;
          return false;
        }
        if (setCriteriaValue.Status == "CONFIRM") {
          visibleAlertMessage.value = true;
          visibleAlertMessageDescription.value = setCriteriaValue.Message;
          option.confirm = true;
          visibleTempVal.value = option;
        }
        cis.initConfiguratorCoding(configuratorStore.apiConfiguratorResult?.ConfiguratorResult.CurrentState?.CurrentCoding ?? []);
        if (configuratorStore.checkAssemblyProduct()) {
          configuratorStore.currentProductAssembly = configuratorStore.getSelectedProduct ?? false;
          configuratorStore.currentProductOptionAssembly = val;
        }
        configuratorStore.currentProductOptionCertificate = val;
        eventBus.emit("optionSelected", true);
        isOptionLoading.value = false;
      }
    };
    const SetCriteriaConfirm = async () => {
      if (configuratorStore.getCurrentState) {
        const loading = openFullLoading(false, t("text.loading"));
        // visibleTempVal.value["confirm"] = true;
        const setconf = await configuratorStore.SetApiCriteria(visibleTempVal.value, configuratorStore.getSelectedProduct?.CodeTypeId ?? "");
        configuratorStore.setUserErroredSelectedOption(setconf.CurrentState.CurrentCriteriaIdx);
        loading.close();
        visibleAlertMessage.value = false;
      }
    };
    // eventBus.on("resetConfigurator", (res: boolean) => {
    //   if (res) {
    //     getOptions("1");
    //     eventBus.emit("resetConfigurator", false);
    //   }
    // });
    onBeforeMount(async () => {
      const loading = openFullLoading(false, t("text.loading"));
      const cnfg = await configuratorStore.setSelectedConfig();
      if (cnfg.Status === "ERROR") {
        ElNotification.closeAll();
        const loginStore = useLoginStore();
        await loginStore.LoginToStore();
        await configuratorStore.initilizeConfigurator();
        await configuratorStore.setSelectedConfig();
        console.log(cnfg.ErrorText);
        // directLogout();
      }
      if (configuratorStore.getCurrentState?.CurrentCriteriaIdx) {
        isOpen.value = configuratorStore.getCurrentState?.CurrentCriteriaIdx;
      }
      loading.close();
      if (useAdditionalAttrStore().dataConfig.promoSectionEnabled == true && localStorage.getItem("promoSection") !== "hide") {
        setTimeout(() => {
          useLoaderStore().setPromoSectionLoading(true);
        }, 2000);
      } else {
        useLoaderStore().setPromoSectionLoading(false);
      }
      eventBus.emit("configuratorHandleInitConfigurator", true);
    });
    // const spacer = h(ElDivider, { direction: "vertical" });
    return (_ctx, _cache) => {
      const _component_optional_certificate_dialog = _resolveComponent("optional-certificate-dialog");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_input = _resolveComponent("el-input");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_collapse_item = _resolveComponent("el-collapse-item");
      const _component_el_collapse = _resolveComponent("el-collapse");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_button = _resolveComponent("el-button");
      const _component_CleaveNumberInput = _resolveComponent("CleaveNumberInput");
      const _component_el_skeleton = _resolveComponent("el-skeleton");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(OptionalAssemblyDialog, {
        modelValue: assemblyDialogVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => assemblyDialogVisible.value = $event),
        "show-close": false
      }, null, 8, ["modelValue"]), _createVNode(_component_optional_certificate_dialog, {
        modelValue: certificateDialogVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => certificateDialogVisible.value = $event)
      }, null, 8, ["modelValue"]), _createVNode(ProductProducts, {
        currentState: _unref(configuratorStore).getCurrentState,
        refLeftContent: refLeftContent.value,
        refRightContent: props.refRightContent
      }, null, 8, ["currentState", "refLeftContent", "refRightContent"]), _createElementVNode("div", {
        class: "container",
        ref_key: "refLeftContent",
        ref: refLeftContent
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(ProductOptions), _createVNode(OverlayComponent, {
        showLoading: showLoading.value
      }, null, 8, ["showLoading"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_collapse, {
        modelValue: activeFilter.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => activeFilter.value = $event),
        class: "collapse-filter",
        accordion: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_collapse_item, {
          name: "filter"
        }, {
          title: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(activeFilterTitle.value), 1), _createElementVNode("div", {
            class: "filter-group",
            onClick: handleFilterGroup
          }, [_createVNode(_component_el_checkbox, {
            modelValue: groupSameStatus.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => groupSameStatus.value = $event),
            label: "false"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("link.groupSameStatus")), 1)]),
            _: 1
          }, 8, ["modelValue"])]), _unref(attribute).getDataConfig.displayGroupCriteriaChekbox ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "filter-group smart-group",
            onClick: handleFilterGroupSmart
          }, [_createVNode(_component_el_checkbox, {
            modelValue: groupSameCriteriaStatus.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => groupSameCriteriaStatus.value = $event),
            label: "false"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("link.groupSameStatusCriteria")), 1)]),
            _: 1
          }, 8, ["modelValue"])])) : _createCommentVNode("", true)])]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_dropdown, {
            ref_key: "controlDropdown",
            ref: controlDropdown,
            trigger: "click",
            class: "control-dropdown",
            "popper-class": "configurator-dropdown dropdown-checkbox",
            "hide-on-click": false
          }, {
            dropdown: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
              modelValue: criteriasFilter.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => criteriasFilter.value = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_checkbox, {
                onChange: applyCriteriasFilter,
                label: "completed"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("status.completed")), 1)]),
                _: 1
              }), _createVNode(_component_el_checkbox, {
                onChange: applyCriteriasFilter,
                label: "missing"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("status.missing")), 1)]),
                _: 1
              }), _createVNode(_component_el_checkbox, {
                onChange: applyCriteriasFilter,
                label: "conflict"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("status.conflict")), 1)]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"]), _createElementVNode("li", _hoisted_8, [_createVNode(_component_el_link, {
              onClick: resetCriteriasFilter
            }, {
              default: _withCtx(() => [_cache[13] || (_cache[13] = _createElementVNode("i", {
                class: "iconfont icon-reset"
              }, null, -1)), _createTextVNode(" " + _toDisplayString(_ctx.$t("button.resetAll")), 1)]),
              _: 1
            })])]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_cache[12] || (_cache[12] = _createElementVNode("i", {
              class: "iconfont icon-filter"
            }, null, -1)), _createVNode(_component_el_input, {
              value: _ctx.$t('text.placeholderFilter'),
              readonly: ""
            }, null, 8, ["value"]), _createVNode(_component_svg_icon, {
              "icon-class": "chevron-down-1"
            })])]),
            _: 1
          }, 512), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(criteriasFilterResult.value, (item, key) => {
            return _openBlock(), _createElementBlock("div", {
              class: "item",
              key: key,
              "data-status": item
            }, [_createTextVNode(_toDisplayString(transFilterResult(item)) + " ", 1), _createElementVNode("i", {
              class: "iconfont icon-close",
              onClick: $event => removeCriteriasFilterByKey(key)
            }, null, 8, _hoisted_11)], 8, _hoisted_10);
          }), 128)), criteriasFilterResult.value.length ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "last",
            onClick: resetCriteriasFilter
          }, [_createTextVNode(_toDisplayString(_ctx.$t("button.resetAll")) + " ", 1), _cache[14] || (_cache[14] = _createElementVNode("i", {
            class: "iconfont icon-reset"
          }, null, -1))])) : _createCommentVNode("", true)])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])])]), _unref(configuratorStore).getCurrentState ? (_openBlock(), _createBlock(_component_el_collapse, {
        key: 0,
        class: "collapse-results",
        modelValue: resultFilter.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => resultFilter.value = $event),
        accordion: "",
        onChange: handleResultChange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupSameStatus.value ? sortCriteriaValues(getFilteredValues.value ?? []) : getFilteredValues.value, Criterias => {
          return _withDirectives((_openBlock(), _createBlock(_component_el_collapse_item, {
            key: Criterias?.CriteriaIdx,
            name: Criterias?.CriteriaIdx,
            class: _normalizeClass(getStatusClass(Criterias, Criterias?.NettoOption)),
            onMouseenter: $event => handleHoverEnter(Criterias),
            onMouseleave: _cache[6] || (_cache[6] = $event => handleHoverLeave()),
            "data-type": Criterias?.CriteriaId
          }, {
            title: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("i", {
              class: _normalizeClass(getStatusIConClass(Criterias, Criterias?.NettoOption))
            }, null, 2)]), _createElementVNode("span", null, _toDisplayString(Criterias?.Description), 1), isVisibleInfo(Criterias?.CriteriaId) ? (_openBlock(), _createBlock(_component_el_link, {
              key: 0,
              class: "tooltip-item",
              onClick: $event => handleCallInfo(Criterias, $event)
            }, {
              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createElementVNode("span", {
                class: "info"
              }, [_createElementVNode("i", {
                class: "iconfont icon-info"
              })], -1)]))]),
              _: 1
            }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_15, _toDisplayString(Criterias?.ConfiguratorOptionDescription), 1)])]),
            default: _withCtx(() => [_unref(configuratorStore).getCurrentOptions && !isOptionLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("ul", {
              class: "list",
              "data-flex": isPaneContentFlex(_unref(configuratorStore).getCurrentOptions)
            }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(configuratorStore).getCurrentOptions, option => {
              return _openBlock(), _createElementBlock("li", {
                key: option.OptionId,
                "data-invalid": option.Invalid,
                "data-edit": option.IsVariableOption,
                onClick: $event => option.IsTextOption || option.IsVariableOption || option.Selected ? '' : SetCriteria(option),
                class: _normalizeClass({
                  active: option.Selected || option.TextOptionValue && option.IsTextOption,
                  'flex-item': option.ImageName
                })
              }, [option.Invalid ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                "popper-class": "tooltip-item",
                content: _ctx.$t('label.optionChange'),
                placement: "top"
              }, {
                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("text", -1)]))]),
                _: 1
              }, 8, ["content"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_19, [option.ImageName ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [_createVNode(_component_el_image, {
                style: {
                  "width": "200px",
                  "height": "200px"
                },
                fit: "contain",
                src: _unref(attribute).config.optionGraphicSettings + option.ImageName
              }, null, 8, ["src"]), option.ImageName ? (_openBlock(), _createElementBlock("i", _hoisted_20)) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
                key: 1
              }, [displayHolderImage.value ? (_openBlock(), _createBlock(_component_el_image, {
                key: 0,
                style: {
                  "width": "200px",
                  "height": "200px"
                },
                fit: "contain",
                src: placeholderImage.value
              }, null, 8, ["src"])) : _createCommentVNode("", true), displayHolderImage.value ? (_openBlock(), _createElementBlock("i", _hoisted_21)) : _createCommentVNode("", true)], 64)), option.IsTextOption ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 2
              }, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", {
                class: _normalizeClass(option.ImageName || displayHolderImage.value ? 'has-image' : '')
              }, [!(option.ImageName || displayHolderImage.value) ? (_openBlock(), _createElementBlock("i", _hoisted_23)) : _createCommentVNode("", true), _createElementVNode("strong", null, [_createTextVNode(_toDisplayString(option.ConfiguratorOptionDescription) + " ", 1), _withDirectives(_createElementVNode("span", {
                class: "o5"
              }, "(" + _toDisplayString(option.OptionId) + ")", 513), [[_vShow, _unref(attribute).dataConfig.showOptionId]])])], 2), _createVNode(_component_el_tooltip, {
                "popper-class": "tooltip-item",
                placement: "left",
                effect: "gray",
                "hide-after": autoCloseNum.value
              }, {
                content: _withCtx(() => [_createElementVNode("div", {
                  innerHTML: checkDeliveryText(option)
                }, null, 8, _hoisted_24)]),
                default: _withCtx(() => [_createElementVNode("i", {
                  class: _normalizeClass(checkDeliverySpeed(option))
                }, null, 2)]),
                _: 2
              }, 1032, ["hide-after"])]), _createElementVNode("div", _hoisted_25, [_createVNode(_component_el_input, {
                modelValue: option.TextOptionValue,
                "onUpdate:modelValue": $event => option.TextOptionValue = $event,
                maxlength: "200",
                class: "limit-input",
                placeholder: "Type something ...",
                "show-word-limit": "",
                type: "textarea",
                autosize: {
                  minRows: 1,
                  maxRows: 10
                },
                rows: 1
              }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createVNode(_component_el_button, {
                onClick: $event => SetCriteria(option),
                type: "primary"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("button.ok")), 1)]),
                _: 1
              }, 8, ["onClick"])])], 64)) : option.IsVariableOption ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 3
              }, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", {
                class: _normalizeClass(option.ImageName || displayHolderImage.value ? 'has-image' : '')
              }, [!(option.ImageName || displayHolderImage.value) ? (_openBlock(), _createElementBlock("i", _hoisted_27)) : _createCommentVNode("", true), _createElementVNode("strong", null, _toDisplayString(option.ConfiguratorOptionDescription), 1)], 2), _createVNode(_component_el_tooltip, {
                "popper-class": "tooltip-item",
                placement: "left",
                effect: "gray",
                "hide-after": autoCloseNum.value
              }, {
                content: _withCtx(() => [_createElementVNode("div", {
                  class: "tooltip-desc",
                  innerHTML: checkDeliveryText(option)
                }, null, 8, _hoisted_28)]),
                default: _withCtx(() => [_createElementVNode("i", {
                  class: _normalizeClass(checkDeliverySpeed(option))
                }, null, 2)]),
                _: 2
              }, 1032, ["hide-after"])]), _createElementVNode("div", _hoisted_29, [_createVNode(_component_CleaveNumberInput, {
                modelValue: option.VariableValue,
                "onUpdate:modelValue": $event => option.VariableValue = $event,
                separator: option.VarDecimalSeparator,
                decimalsCount: Number(option.VarDecimalsCount),
                digitCount: Number(option.VarDigitCount),
                max: Number(option.VarMaxValue),
                min: Number(option.VarMinValue),
                thousandsSeparator: option.VarThousandsSeparator,
                placeholder: `${'0'.repeat(option.VarDigitCount - option.VarDecimalsCount)}${option.VarDecimalsCount > 0 ? option.VarDecimalSeparator : ''}${option.VarDecimalsCount > 0 ? '0'.repeat(option.VarDecimalsCount) : ''}`,
                setActive: () => setActive(option),
                onKeydown: _withKeys($event => SetCriteria(option), ["enter"])
              }, null, 8, ["modelValue", "onUpdate:modelValue", "separator", "decimalsCount", "digitCount", "max", "min", "thousandsSeparator", "placeholder", "setActive", "onKeydown"]), _createVNode(_component_el_button, {
                onClick: $event => SetCriteria(option),
                type: "primary"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("button.ok")), 1)]),
                _: 1
              }, 8, ["onClick"])])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_30, [_createElementVNode("div", {
                class: _normalizeClass(option.ImageName || displayHolderImage.value ? 'has-image checkbox-products' : 'checkbox-products')
              }, [!(option.ImageName || displayHolderImage.value) ? (_openBlock(), _createElementBlock("i", _hoisted_31)) : _createCommentVNode("", true), _createTextVNode(_toDisplayString(option.ConfiguratorOptionDescription), 1), _withDirectives(_createElementVNode("span", {
                class: "o5"
              }, "(" + _toDisplayString(option.OptionId) + ")", 513), [[_vShow, _unref(attribute).dataConfig.showOptionId]])], 2), _createVNode(_component_el_tooltip, {
                "popper-class": "tooltip-item",
                placement: "left",
                effect: "gray",
                "hide-after": autoCloseNum.value
              }, {
                content: _withCtx(() => [_createElementVNode("div", {
                  class: "tooltip-desc",
                  innerHTML: checkDeliveryText(option)
                }, null, 8, _hoisted_32)]),
                default: _withCtx(() => [_createElementVNode("i", {
                  class: _normalizeClass(checkDeliverySpeed(option))
                }, null, 2)]),
                _: 2
              }, 1032, ["hide-after"])]))])], 10, _hoisted_18);
            }), 128))], 8, _hoisted_17)])) : (_openBlock(), _createElementBlock("div", _hoisted_33, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_34, [_createVNode(_component_el_skeleton, {
              animated: "",
              row: "2"
            })])), [[_directive_loading, loading.value]])]))]),
            _: 2
          }, 1032, ["name", "class", "onMouseenter", "data-type"])), [[_vShow, Criterias?.Description && filterContent(Criterias)]]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), optionalCriterias.value.length && (!groupSameCriteriaStatus.value || !_unref(attribute).getDataConfig.displayGroupCriteriaChekbox) ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t("header.optionalConfiguration")), 1), _createVNode(_component_el_collapse, {
        class: "collapse-results",
        modelValue: resultFilter.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => resultFilter.value = $event),
        onChange: handleResultChange,
        accordion: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupSameStatus.value ? sortCriteriaValues(optionalCriterias.value) : optionalCriterias.value, Criterias => {
          return _withDirectives((_openBlock(), _createBlock(_component_el_collapse_item, {
            key: Criterias?.CriteriaIdx,
            name: Criterias?.CriteriaIdx,
            class: _normalizeClass(getStatusClass(Criterias, Criterias?.NettoOption))
          }, {
            title: _withCtx(() => [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("i", {
              class: _normalizeClass(getStatusIConClass(Criterias, Criterias?.NettoOption))
            }, null, 2)]), _createElementVNode("span", _hoisted_39, _toDisplayString(Criterias?.Description), 1), isVisibleInfo(Criterias?.CriteriaId) ? (_openBlock(), _createBlock(_component_el_link, {
              key: 0,
              class: "tooltip-item",
              onClick: $event => handleCallInfo(Criterias, $event)
            }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createElementVNode("span", {
                class: "info"
              }, [_createElementVNode("i", {
                class: "iconfont icon-info"
              })], -1)]))]),
              _: 1
            }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_40, _toDisplayString(Criterias?.ConfiguratorOptionDescription), 1)])]),
            default: _withCtx(() => [_unref(configuratorStore).getCurrentOptions && !isOptionLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createElementVNode("ul", {
              class: "list",
              "data-flex": isPaneContentFlex(_unref(configuratorStore).getCurrentOptions)
            }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(configuratorStore).getCurrentOptions, option => {
              return _openBlock(), _createElementBlock("li", {
                key: option.OptionId,
                onClick: $event => option.IsTextOption || option.IsVariableOption || option.Selected ? '' : SetCriteria(option),
                class: _normalizeClass({
                  active: option.Selected || option.TextOptionValue && option.IsTextOption,
                  'flex-item': option.ImageName
                }),
                "data-invalid": option.Invalid,
                "data-edit": option.IsVariableOption
              }, [_createElementVNode("div", _hoisted_44, [option.ImageName ? (_openBlock(), _createBlock(_component_el_image, {
                key: 0,
                style: {
                  "width": "200px",
                  "height": "200px"
                },
                fit: "contain",
                src: _unref(attribute).config.optionGraphicSettings + option.ImageName
              }, null, 8, ["src"])) : (_openBlock(), _createElementBlock(_Fragment, {
                key: 1
              }, [displayHolderImage.value ? (_openBlock(), _createBlock(_component_el_image, {
                key: 0,
                style: {
                  "width": "200px",
                  "height": "200px"
                },
                fit: "contain",
                src: placeholderImage.value
              }, null, 8, ["src"])) : _createCommentVNode("", true)], 64)), option.IsTextOption ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 2
              }, [_createElementVNode("div", _hoisted_45, [_createElementVNode("div", null, [!(option.ImageName || displayHolderImage.value) ? (_openBlock(), _createElementBlock("i", _hoisted_46)) : _createCommentVNode("", true), _createElementVNode("strong", null, _toDisplayString(option.ConfiguratorOptionDescription), 1)]), _createVNode(_component_el_tooltip, {
                "popper-class": "tooltip-item",
                placement: "left",
                effect: "gray",
                "hide-after": autoCloseNum.value
              }, {
                content: _withCtx(() => [_createElementVNode("div", {
                  class: "tooltip-desc",
                  innerHTML: checkDeliveryText(option)
                }, null, 8, _hoisted_47)]),
                default: _withCtx(() => [_createElementVNode("i", {
                  class: _normalizeClass(checkDeliverySpeed(option))
                }, null, 2)]),
                _: 2
              }, 1032, ["hide-after"])]), _createElementVNode("div", _hoisted_48, [_createVNode(_component_el_input, {
                modelValue: option.TextOptionValue,
                "onUpdate:modelValue": $event => option.TextOptionValue = $event,
                maxlength: "200",
                class: "limit-input",
                placeholder: "Type something ...",
                "show-word-limit": "",
                type: "textarea",
                autosize: {
                  minRows: 1,
                  maxRows: 10
                },
                rows: 1
              }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createVNode(_component_el_button, {
                onClick: $event => SetCriteria(option),
                type: "primary"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("button.ok")), 1)]),
                _: 1
              }, 8, ["onClick"])])], 64)) : option.IsVariableOption ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 3
              }, [_createElementVNode("div", _hoisted_49, [_createElementVNode("div", null, [!(option.ImageName || displayHolderImage.value) ? (_openBlock(), _createElementBlock("i", _hoisted_50)) : _createCommentVNode("", true), _createElementVNode("strong", null, _toDisplayString(option.ConfiguratorOptionDescription), 1)]), _createVNode(_component_el_tooltip, {
                "popper-class": "tooltip-item",
                placement: "left",
                effect: "gray",
                "hide-after": autoCloseNum.value
              }, {
                content: _withCtx(() => [_createElementVNode("div", {
                  class: "tooltip-desc",
                  innerHTML: checkDeliveryText(option)
                }, null, 8, _hoisted_51)]),
                default: _withCtx(() => [_createElementVNode("i", {
                  class: _normalizeClass(checkDeliverySpeed(option))
                }, null, 2)]),
                _: 2
              }, 1032, ["hide-after"])]), _createElementVNode("div", _hoisted_52, [_createVNode(_component_el_input, {
                modelValue: option.VariableValue,
                "onUpdate:modelValue": $event => option.VariableValue = $event,
                placeholder: "Type something ...",
                class: "limit-input",
                onInput: $event => setActive(option)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"]), _createVNode(_component_el_button, {
                onClick: $event => SetCriteria(option),
                type: "primary"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("button.ok")), 1)]),
                _: 1
              }, 8, ["onClick"])])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_53, [_createElementVNode("div", null, [!(option.ImageName || displayHolderImage.value) ? (_openBlock(), _createElementBlock("i", _hoisted_54)) : _createCommentVNode("", true), _createElementVNode("strong", null, _toDisplayString(option.ConfiguratorOptionDescription), 1)]), _createVNode(_component_el_tooltip, {
                "popper-class": "tooltip-item",
                placement: "left",
                effect: "gray",
                "hide-after": autoCloseNum.value
              }, {
                content: _withCtx(() => [_createElementVNode("div", {
                  class: "tooltip-desc",
                  innerHTML: checkDeliveryText(option)
                }, null, 8, _hoisted_55)]),
                default: _withCtx(() => [_createElementVNode("i", {
                  class: _normalizeClass(checkDeliverySpeed(option))
                }, null, 2)]),
                _: 2
              }, 1032, ["hide-after"])]))])], 10, _hoisted_43);
            }), 128))], 8, _hoisted_42)])) : (_openBlock(), _createElementBlock("div", _hoisted_56, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_57, [_createVNode(_component_el_skeleton, {
              animated: "",
              row: "2"
            })])), [[_directive_loading, loading.value]])]))]),
            _: 2
          }, 1032, ["name", "class"])), [[_vShow, Criterias?.Description && filterContent(Criterias)]]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])])) : _createCommentVNode("", true)])], 512), _createVNode(_component_el_dialog, {
        modelValue: visibleAlertMessage.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => visibleAlertMessage.value = $event),
        "modal-class": "configurator-popup",
        "show-close": true,
        "append-to-body": true,
        width: "808px",
        center: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_58, [_cache[18] || (_cache[18] = _createElementVNode("div", {
          class: "ic"
        }, [_createElementVNode("i", {
          class: "iconfont icon-info"
        })], -1)), _createElementVNode("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.status")), 1), _createElementVNode("p", {
          innerHTML: visibleAlertMessageDescription.value.replace(/\n/g, '<br>')
        }, null, 8, _hoisted_62)]), _createElementVNode("div", _hoisted_63, [_createElementVNode("div", {
          class: "wikaButtonConf",
          "data-colour": "white",
          "data-no-border": "",
          onClick: _cache[9] || (_cache[9] = $event => visibleAlertMessage.value = !visibleAlertMessage.value),
          "data-text": _ctx.$t('button.cancel'),
          "data-type": "button"
        }, _toDisplayString(_ctx.$t("button.cancel")), 9, _hoisted_64), _createElementVNode("div", {
          class: "wikaButtonConf",
          "data-colour": "blue",
          "data-no-border": "",
          onClick: SetCriteriaConfirm,
          "data-text": _ctx.$t('button.overwrite'),
          "data-type": "button",
          "element-loading-svg": svg
        }, _toDisplayString(_ctx.$t("button.overwrite")), 9, _hoisted_65)])])])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: visibleInfoDialog.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => visibleInfoDialog.value = $event),
        "modal-class": "configurator-popup",
        "show-close": true,
        "append-to-body": true,
        width: "808px",
        center: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [_createVNode(_component_svg_icon, {
          "icon-class": "info"
        })]), _createElementVNode("div", _hoisted_68, [_createElementVNode("h2", _hoisted_69, _toDisplayString(visibleInfoHeadline.value), 1), _createElementVNode("div", {
          class: "content content-inner",
          innerHTML: visibleInfoText.value
        }, null, 8, _hoisted_70)])])]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
});